module.exports = __webpack_public_path__ + "static/media/IconoPila-full.3618da48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/IconoPila-full.svg
// module id = 118
// module chunks = 0